import { useEffect, useLayoutEffect, useRef } from "react";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import { sendSaveModuleIdHistory } from "../../services/apis";

export const useEditorBannerAssetLifecycle = ({
  bannerId,
  getEditSaveAssets,
}) => {
  const getEditSaveAssetsRef = useRef(getEditSaveAssets);

  useEffect(() => {
    getEditSaveAssetsRef.current = getEditSaveAssets;
  }, [getEditSaveAssets]);

  useLayoutEffect(() => {
    if (bannerId) {
      getEditSaveAssetsRef.current(bannerId);
    }
  }, [bannerId]);

  useEffect(() => {
    if (bannerId)
      sendSaveModuleIdHistory(
        {
          contentType: "Banner",
          contentId: [bannerId],
        },
        (response, err, errorCode) => {
          if (err) {
            ErrComponentToRender(errorCode);
          } else {
          }
        },
      );
  }, [bannerId]);
};
